var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{style:({
          position: _vm.position,
          opacity: _vm.opacity,
          transform: _vm.transform,
          top: _vm.top,
          left: _vm.left
        }),attrs:{"id":"navLogo","to":"/"}},[_c('span',{staticClass:"small"},[_vm._v("small")]),_vm._v("Sky\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }